// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./btdraw/static/css/site_index.sass
// module id = 378
// module chunks = 4